/* @flow */
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { connect } from "react-redux";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { signOut } from "../../common/auth/actions";
import md5 from "md5";

const Logo = ({ appPath }) => (
  <div className="logo">
    <Link to={appPath}>
      <i className="fa fa-heartbeat fa-2x logo-icon" />
      <div className="logo-text">OpiekujSię</div>
    </Link>
  </div>
);

class ProfileImage extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpen: false
    };

    this.toggle = this.toggle.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  signOut() {
    const { signOut, appPath } = this.props;

    signOut();
    window.location.href = `${appPath}/signin`;
  }

  render() {
    const { email, appPath } = this.props;
    const emailMD5 = email && md5(email);
    return (
      <div>
        <Dropdown isOpen={this.state.isOpen} toggle={this.toggle}>
          <img
            id="profile-image"
            className="profile-image"
            src={"https://www.gravatar.com/avatar/" + emailMD5 + "?s=40&d=mm"}
            onClick={this.toggle}
          />
          <DropdownMenu>
            <DropdownItem header>
              {email || <i className="fa fa-circle-o-notch fa-spin" />}
            </DropdownItem>
            <DropdownItem
              onClick={this.redirect.bind(this, `${appPath}/profile`)}
            >
              <i className="fa fa-cog" />Ustawienia
            </DropdownItem>
            <DropdownItem onClick={this.signOut}>
              <i className="fa fa-sign-out" />Wyloguj się
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}
ProfileImage.contextTypes = {
  router: React.PropTypes.object.isRequired
};
ProfileImage = connect(state => ({}), { signOut })(ProfileImage);

const Header = ({ title, viewer, appPath }) => (
  <header>
    <Row className="flex-items-xs-middle">
      <Col xs="2">
        <Logo appPath={appPath} />
      </Col>
      <Col xs="8">
        <div className="title">{title}</div>
      </Col>
      <Col className="text-xs-right" xs="2">
        <ProfileImage email={viewer && viewer.email} appPath={appPath} />
      </Col>
    </Row>
  </header>
);

export default connect(
  state => ({
    viewer: state.auth.viewer,
    appPath: state.config.appPath
  }),
  { signOut }
)(Header);



// WEBPACK FOOTER //
// ./src/browser/app/Header.js